import { render, staticRenderFns } from "./Variacoes.vue?vue&type=template&id=0ef930ae&scoped=true"
import script from "./Variacoes.vue?vue&type=script&lang=js"
export * from "./Variacoes.vue?vue&type=script&lang=js"
import style0 from "./Variacoes.vue?vue&type=style&index=0&id=0ef930ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef930ae",
  null
  
)

export default component.exports